<!--
 * @Author: 张天昊
 * @Date: 2024-05-21 14:42:18
 * @LastEditTime: 2024-11-05 11:28:39
 * @LastEditors: 张天昊
 * @Description: 行程单类型tag
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/PrimaryTag.vue
-->
<script>
import { defineComponent, ref, computed } from 'vue';
import { TeamTypeMap } from '../constants';

export default defineComponent({
  props: {
    type: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const popupShow = ref(false);
    const abbr = computed(() => TeamTypeMap.get(props.type)?.abbr ?? '');
    const fullName = computed(
      () => TeamTypeMap.get(props.type)?.fullName ?? ''
    );
    function genColor() {
      switch (props.type) {
        case '4':
          return '#B08FE5';
        case '3':
          return '#2D71DE';
        case '2':
          return '#FF8C19';
        case '1':
          return '#6DB5FF';
        default:
          return '#20CB75';
      }
    }
    return {
      popupShow,
      abbr,
      fullName,
      genColor
    };
  }
});
</script>

<template>
  <span v-if="abbr">
    <!-- TODO svg + 点9图 -->
    <van-popover
      v-model="popupShow"
      class="custom-popover"
      trigger="click"
      theme="dark"
      placement="bottom-start"
    >
      <div class="text-14 leading-20 py-8 px-12">
        <div>团队类型全称</div>
        <div>{{ fullName }}</div>
      </div>
      <template #reference>
        <van-tag class="primary-tag" :color="genColor()">
          {{ abbr
          }}<van-icon :style="{ marginLeft: $px2rem(3) }" name="info-o" />
        </van-tag>
      </template>
    </van-popover>
  </span>
</template>

<style scoped>
.primary-tag {
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  border-radius: 4px;
  padding-left: 7px;
  padding-right: 8.5px;
}
</style>
